export const environment = {
  production: false,
  supabase: {
    url: 'https://ofnjqqpnduzxkrsalqml.supabase.co',
    key: 'sb_publishable_X-J8dVTEPl8xRhGkqmM61w_ljeoIuLY',
  },
  app: {
    env: '[DEV]',
  },
};
